export enum SELECT_CHANGE_FORM_TYPE_QUERY_KEY {
  DOCUMENT_ID = 'documentId',
}
